/* eslint-disable */


const resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;

const loadGMap = function (initializeGMAP) {
  if (!initializeGMAP)
    initializeGMAP = 'initializeGMAP';
  var s = document.createElement('script');
  s.id = 'googleMapsScript';
  var GOOGLE_CLIENT_API_KEY = "client=gme-dsgretaillimited2";
  s.src = 'https://maps.googleapis.com/maps/api/js?' +
    GOOGLE_CLIENT_API_KEY +
    '&sensor=false&libraries=places&callback=' +
    initializeGMAP;
  document.body.appendChild(s);
};

let geocode = function (elt) {
  const initGeocode = function (elt) {
    $(elt).each(function () {
      var el = $(this)
        , geoIn = $('<input type="hidden" name="sStoreGeo">')
        , autoOpts = { types: ['geocode'], componentRestrictions: { country: resolveByCountry(['uk', 'im'], 'irl') } }
        , geocoder = new google.maps.Geocoder()
        , autocomplete = new google.maps.places.Autocomplete(el[0], autoOpts);

      geoIn.insertBefore(el);

      // Form submit rewrite on keyboard
      el.bind('focus', function () {

        $(this).bind('keydown', function (e) {
          if (e.keyCode === 13) {
            e.preventDefault();
            el.blur();
            el.next(':button')[0].click();
          }
        })
      });

      el.bind('keyup change', function () {
        var $this = $(this);

        if ($this.val() != '') {
          $this.addClass('dirty');
        } else {
          $this.removeClass('dirty');
        }
      });

      geocode = function (a) {
        geocoder.geocode({address: a}, function (res, stat) {
          if (stat === google.maps.GeocoderStatus.OK) {
            geoIn[0].value = [res[0].geometry.location.lat(), res[0].geometry.location.lng()];
          }
        })
      };

      // Update lat/lng if the input has a value on load
      //if ( el.val() != '' || el.val() != 'null' ) geocode(el.val())

      // Autocomplete on change
      google.maps.event.addListener(autocomplete, 'place_changed', function () {
        var place = autocomplete.getPlace();
        if (el.val().length > 4 && place.geometry) {
          geoIn[0].value = [place.geometry.location.lat(), place.geometry.location.lng()];
        }
      })

    })
  };
  initGeocode(elt);
};

module.exports = {
  geocode,
  loadGMap
};
